import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollUp = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    const handleScroll = () => {
      setTimeout(() => {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      });
    };
    handleScroll();
  }, [pathname]);

  return (
    null
  );
};

export default ScrollUp;
